var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35205 6.38596C1.36189 3.44847 3.71874 1.07526 6.61621 1.08524C9.51368 1.09522 11.8546 3.48461 11.8447 6.4221V6.48234C11.8091 8.3918 10.7574 10.1567 9.46812 11.5361C8.73077 12.3124 7.90736 12.9996 7.01429 13.5841C6.77549 13.7935 6.42128 13.7935 6.18248 13.5841C4.85113 12.7056 3.68264 11.5964 2.73048 10.3073C1.88182 9.18318 1.39999 7.81878 1.35205 6.40403L1.35205 6.38596Z",
    stroke: "black",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59843,
    cy: 6.48811,
    rx: 1.68144,
    ry: 1.70466,
    stroke: "black",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.01d272078ad4bc87c17117e8fec01086.svg";
export { ForwardRef as ReactComponent };